import { NoteTypes } from "../types/notes.types";
import { CPT_CODES_PSYCHO } from "../../../utils/constants";
import { isPsychNote } from "./notes.helpers";

export interface NoteCptContext {
    note_type: NoteTypes;
    cpt_code?: string | null;
    additional_cpt_codes?: string[] | null;
    appointment_type?: string;
}

const medEvaluationCodes = ["99212", "99213", "99214", "99215"];
const medTherapyAddOnCodes = ["90833", "90836", "90838"];
const ketamineAdministrationCode = "96365";
const ketamineAppointmentType = "ketamine_assisted_psychotherapy";

export const noteTypesWithoutCptCode: NoteTypes[] = [
    NoteTypes.CANCELLATION_NOTE,
    NoteTypes.FORMS_AND_DOCUMENTATION_NOTE,
    NoteTypes.CONSULTATION_NOTE_MED,
    NoteTypes.DOCUMENTATION_REQUEST_NOTE_MED,
    NoteTypes.EVALUATION_SUBMISSION_NOTE_MED,
    NoteTypes.NO_SHOW_NOTE_MED,
];

export function getPrimaryCptCodes(note: NoteCptContext): string[] {
    if (noteTypesWithoutCptCode.includes(note.note_type)) return [];

    switch (note.note_type) {
        case NoteTypes.INTAKE_NOTE_MED:
            return ["99203", "99204", "99205"];
        case NoteTypes.NUTRITION_NOTE_MED:
            return ["97802", "97803"];
        case NoteTypes.EVALUATION_MANAGEMENT_NOTE_MED:
        case NoteTypes.EVALUATION_MANAGEMENT_AND_THERAPY_NOTE_MED:
        case NoteTypes.TREATMENT_REVIEW_NOTE_MED:
        case NoteTypes.TERM_OF_CARE_NOTE_MED:
            return medEvaluationCodes;
        default:
            return isPsychNote(note.note_type) ||
                !Object.values(NoteTypes).includes(note.note_type)
                ? []
                : CPT_CODES_PSYCHO;
    }
}

export function getAdditionalCptCodes(note: NoteCptContext): string[] {
    if (
        note.note_type === NoteTypes.EVALUATION_MANAGEMENT_NOTE_MED &&
        note.appointment_type === ketamineAppointmentType
    ) {
        return [ketamineAdministrationCode];
    }

    return note.note_type ===
        NoteTypes.EVALUATION_MANAGEMENT_AND_THERAPY_NOTE_MED
        ? medTherapyAddOnCodes
        : [];
}

export function getAdditionalCptLabel(note: NoteCptContext): string | null {
    if (
        note.note_type === NoteTypes.EVALUATION_MANAGEMENT_AND_THERAPY_NOTE_MED
    ) {
        return "THERAPY ADD-ON CPT CODE";
    }

    if (
        note.note_type === NoteTypes.EVALUATION_MANAGEMENT_NOTE_MED &&
        note.appointment_type === ketamineAppointmentType
    ) {
        return "KETAMINE ADMINISTRATION CPT CODE";
    }

    return null;
}

export function getPrimaryCptLabel(note: NoteCptContext): string {
    const isEvaluationManagementNote =
        note.note_type === NoteTypes.EVALUATION_MANAGEMENT_NOTE_MED ||
        note.note_type === NoteTypes.EVALUATION_MANAGEMENT_AND_THERAPY_NOTE_MED;

    return isEvaluationManagementNote ? "E/M CPT CODE" : "CPT CODE";
}
